import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SelfServiceService as _selfService } from '@/services/store';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { addDays, isBefore } from 'date-fns';

export const useSelfServicePhysicalMembershipCardStore = defineStore('selfServicePhysicalMembershipCardStore', () => {
  const waitTime = ref<number>();
  const expectedArrivalDate = ref<Date>();
  const membershipCardModal = ref<Record<string, Field<string>>>();
  /**
   * order a card
   */
  const orderCard = async (): Promise<{ value: boolean; expectedArrivalDate: Date }> => {
    const res = await _selfService.orderPhysicalCard();
    return res;
  };

  const calcExpectedDeliveryDate = (membershipCardRequestedDate?: Date) => {
    if (!membershipCardRequestedDate) return;
    const lastRequestDate = membershipCardRequestedDate;
    lastRequestDate && (expectedArrivalDate.value = addDays(lastRequestDate, waitTime.value ?? 0));
  };

  return {
    waitTime,
    expectedArrivalDate,
    orderCard,
    membershipCardModal,
    calcExpectedDeliveryDate,
  };
});
